import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface ISubscribe {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  name?: string;
  background_color?: string;
  title?: string;
  title_color?: string;
  description?: string;
  description_color?: string;
  placeholder_text?: string;
  button_name?: string;
  button_background_color?: string;
  button_text_color?: string;
  button_icon?: string;
  button_icon_alt?: string;
  success_icon?: string;
  success_icon_alt?: string;
  variant?: string;
  status?: boolean;
}

export async function createSubscribe(payload: Partial<ISubscribe>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.SUBSCRIBE.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateSubscribe(id: number, payload: Partial<ISubscribe>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.SUBSCRIBE.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

